package dev.lingvo.site.pages.app.projects.slug.settings

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.navigation.Link
import dev.lingvo.site.ds.LListChecksIcon
import dev.lingvo.site.ds.PageHeader
import dev.lingvo.site.ds.Space
import dev.lingvo.site.i18n.t
import org.jetbrains.compose.web.dom.Text

/**
 * The QA rules of one project, on their own route.
 *
 * **This exists beside the project-settings tab rather than instead of it, and the difference is
 * who may open it.** Every `PROJECT_SETTINGS` tab is ADMIN or OWNER, and the settings page refuses a
 * translator outright — but a translator staring at a blocked approval is exactly the person who
 * needs to know whether the check that blocked it is one their own team chose to enforce. That is
 * why the QA page links here rather than into settings, and why this route stays readable by
 * everyone in the project.
 *
 * The body is [ProjectQaRulesSettings], the same composable the settings tab mounts. Two
 * implementations of a release gate would drift, and the louder copy would win.
 */
@Page("/app/projects/{slug}/settings/qa")
@Layout(".components.layouts.AppLayout")
@Composable
fun ProjectQaSettingsPage() {
    val ctx = rememberPageContext()
    val slug = ctx.route.params["slug"].orEmpty()

    ProjectSettingsSurface {
        Column(Modifier.fillMaxWidth().gap(Space.XL)) {
            PageHeader(
                title = t("app.projects.slug.settings.qa.qa_rules", "QA rules"),
                subtitle = t(
                    "app.projects.slug.settings.qa.what_blocks_a_release_here_and",
                    "What blocks a release here, and what only gets mentioned.",
                ),
                mark = { LListChecksIcon() },
            )
            ProjectQaRulesSettings(slug)
            Row(Modifier.gap(Space.MD)) {
                Link(path = "/app/projects/$slug/qa") {
                    Text(t("app.projects.slug.settings.qa.what_is_failing_right_now", "What is failing right now"))
                }
                Link(path = "/app/projects/$slug/settings") {
                    Text(t("app.projects.slug.settings.qa.project_settings", "Project settings"))
                }
            }
        }
    }
}
